import { ref } from "vue";

/**
 * Bus de notificaciones global.
 *
 * Permite que composables y stores (fuera de setup()) encolen mensajes
 * que App.vue consume y reenvía al Toast de PrimeVue.
 *
 * Uso (desde un composable/store):
 *   import { notify } from "@/composables/useNotificationBus";
 *   notify.error("No se encontró el punto de inicio");
 *
 * Uso (en App.vue para consumir la cola):
 *   import { useNotificationBus } from "@/composables/useNotificationBus";
 *   const { queue, shift } = useNotificationBus();
 *   watch(queue, () => { const n = shift(); if (n) toast.add(n); }, { deep: true });
 */
const _queue = ref([]);

export const notify = {
  success: (summary, detail) =>
    _queue.value.push({ severity: "success", summary, detail, life: 3000 }),
  error: (summary, detail) =>
    _queue.value.push({ severity: "error", summary, detail, life: 5000 }),
  warn: (summary, detail) =>
    _queue.value.push({ severity: "warn", summary, detail, life: 4000 }),
  info: (summary, detail) =>
    _queue.value.push({ severity: "info", summary, detail, life: 3000 }),
};

export function useNotificationBus() {
  return {
    queue: _queue,
    shift: () => _queue.value.shift(),
  };
}
